import { render, staticRenderFns } from "./EditAudience.vue?vue&type=template&id=548032ee&"
import script from "./EditAudience.vue?vue&type=script&lang=js&"
export * from "./EditAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports